import { type JSX, type ParentComponent, Show } from "solid-js";
import { IconButtonWrapper, NotificationDot } from "./styled";

const IconButton: ParentComponent<JSX.ButtonHTMLAttributes<HTMLButtonElement> & { dot?: boolean }> = (props) => {
	return (
		<IconButtonWrapper {...props}>
			{props.children}
			<Show when={props.dot}>
				<NotificationDot />
			</Show>
		</IconButtonWrapper>
	);
};
export default IconButton;
